import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserLogins = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [
        ...userColumns,
        // { field: 'loginDate', name: 'Login', dataType: 'date' },
        { field: 'loginDatetime', name: 'Login ({tz} time zone)', dataType: 'datetime' },
    ];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.loginDate),
    //     {
    //         count: true,
    //         countDistinctFields: ['username'],
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Logins',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    //     {
    //         name: 'Unique Logins',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.usernameCountDistinct),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart data={chartData} chartTitle="User Logins Over Time" />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows individual user login events, tracking each time a
                    user accesses the platform.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Login (UTC)">
                    The date and time when the user logged in. The user's initial
                    registration also counts as a login.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserLogins;
